import type { InternalApiKeysTranslations } from "@/shared/lang/interfaces/internalApiKeys";

import type { InternalApiKeyPermission } from "../types/internalApiKeys.types";

export const INTERNAL_API_KEYS_URL = "/internal/internal-api-keys";
export const INTERNAL_API_KEYS_PATH = "/app/internal-api-keys";

/** Mirrors the backend DTO limits so the form refuses what the API would. */
export const INTERNAL_API_KEY_MAX_IPS = 10;
export const INTERNAL_API_KEY_DEFAULT_RATE_LIMIT = 120;
export const INTERNAL_API_KEY_MAX_RATE_LIMIT = 6000;
export const INTERNAL_API_KEY_USAGE_PAGE_SIZE = 20;

export const PERMISSION_LABEL_KEYS: Record<InternalApiKeyPermission, keyof InternalApiKeysTranslations> = {
  "operation_payments:read": "permission_operation_payments_read",
  "operation_payments:create": "permission_operation_payments_create",
  "operation_payments:cancel": "permission_operation_payments_cancel",
  "clients:read": "permission_clients_read",
  "clients:write": "permission_clients_write",
  "client_accounts:write": "permission_client_accounts_write",
  "cardholders:write": "permission_cardholders_write",
};
